import { useQuery, useQueryClient } from '@tanstack/react-query';
import { AssetType } from 'src/types/assets';
import { AssetService } from 'src/services/assets/asset.service';

type UseAssetArgs = {
  customerId: string;
  siteId: string;
  assetId: string;
};

export const useGetAssetByIdQuery = ({ customerId, siteId, assetId }: UseAssetArgs) => {
  const queryClient = useQueryClient();

  const isEnabled = !!siteId && !!assetId;

  const queryKey = isEnabled ? ['asset', `${customerId}-${siteId}-${assetId}`] : ['asset', 'empty'];

  const { data: asset } = useQuery<AssetType>({
    queryKey,
    queryFn: () =>
      AssetService.getAssetById({
        customerId,
        siteId,
        assetId,
      }),
    staleTime: 0,
    enabled: isEnabled,
    placeholderData: () => queryClient.getQueryData<AssetType>(queryKey),
  });

  return { asset };
};
